export class ViaCep {

    postalCode: string;

	street: string;

	complement: string;

	unit: string;

	district: string;

	city: string;

	stateAbbreviation: string;

	state: string;

	region: string;

	ibgeCode: string;

	giaCode: string;

	areaCode: string;

	siafiCode: string;

}